import { RouteItems, Route } from "sitemap";

/* =====================================================================
   Two-level navigation helpers.
   Level 1 (top nav) = sitemap categories (modules).
   Level 2 (sidebar) = pages of the currently-active module.
   Active module/page is derived from the current pathname.
   ===================================================================== */

// Feather icon per module (presentation only).
export const CATEGORY_ICONS: Record<string, string> = {
  Users: "users",
  Properties: "home",
  Projects: "grid",
  Masters: "database",
  Inquiries: "help-circle",
  Messaging: "message-square",
  "Roles & Access": "shield",
  Subscriptions: "credit-card",
  Analytics: "bar-chart-2",
};

// Length of the matched page path (higher = more specific), or -1 if no match.
const matchLen = (path: string | undefined, pathname: string): number => {
  if (!path) return -1;
  if (pathname === path || pathname.startsWith(path + "/")) return path.length;
  return -1;
};

// The module whose page path best (most specifically) matches the pathname.
export const getActiveModule = (
  modules: RouteItems[],
  pathname: string
): RouteItems | undefined => {
  let best: RouteItems | undefined;
  let bestLen = -1;
  modules.forEach((m) => {
    (m.pages || []).forEach((p) => {
      const len = matchLen(p.path, pathname);
      if (len > bestLen) {
        bestLen = len;
        best = m;
      }
    });
  });
  return best || modules[0];
};

// The page within a module that best matches the pathname.
export const getActivePage = (
  module: RouteItems | undefined,
  pathname: string
): Route | undefined => {
  if (!module) return undefined;
  let best: Route | undefined;
  let bestLen = -1;
  (module.pages || []).forEach((p) => {
    const len = matchLen(p.path, pathname);
    if (len > bestLen) {
      bestLen = len;
      best = p;
    }
  });
  return best || module.pages?.[0];
};

// Where a module link should navigate: its first real page path.
export const moduleTarget = (m: RouteItems): string =>
  m.pages?.[0]?.path || m.path || "#!";
